import React from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';

const Loader = ({ message }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      gap="2vh"
    >
      <CircularProgress 
        size="4vh"
        sx={{ 
          width: '4vh !important', 
          height: '4vh !important',
          color: '#48CDFF !important',
          '& svg': {
            width: '4vh',
            height: '4vh'
          }
        }} 
      />
      <Typography 
        sx={{ 
          color: 'white !important', 
          fontSize: '2vh !important',
          letterSpacing: '0.064vh !important',
          fontWeight: '100 !important',
          lineHeight: 'normal !important'
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default Loader;
